@if ($model() != null && $currentUser() != null) {
    <div class="wrapper px-1">
        <!-- Seletor de papel -->
        @if ($shouldLetPublicAgentInteract() && $hasPendingTask() && $papeisSelector().length > 0 && !$isReadOnly() && !$hasErrors() && !$isProcessLocationInvalid()) {
            <papel-selector [_signerId]="$inputData().eDocsData.signerId"
                            [_isReadOnly]="$isReadOnly()"
                            [_papeis]="$papeisSelector()"
                            [_flowObjectType]="FlowObjectType.TaskRegisterProcess"
                            (_signerIdChange)="signerIdChange($event)"
            ></papel-selector>
            <hr />
        }

        <!-- Task body: visão do executor -->
        @if ($shouldLetPublicAgentInteract()) {
            <!-- Documentos entranhados -->
            <div class="message-container">
                <div>Documentos entranhados:</div>
                <div class="documents-container my-3">
                    @for (doc of $previousDocuments(); track doc) {
                        <div class="position-relative my-1">
                            <span class="document-highlight" (click)="openDocumentModal(doc.id)" (keyDown)="openDocumentModal(doc.id)">
                                <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do documento">{{doc.registro}}</span>
                                <span class="info-font d-inline-block" matTooltip="Clique para visualizar o documento que foi capturado no E-Docs">
                                    <i class="fas fa-external-link-alt mr-2"></i><u>{{doc.filename}}</u>
                                </span>
                            </span>
                        </div>
                    }
                </div>
                <hr />
            </div>

            <!-- Local de Autuação -->
            <div class="message-container">
                <div>Local de Autuação:</div>
                <div class="my-3">
                    <span class="uppercase info-font text-highlight d-inline-block">
                        {{$configSchema()?.taskRegisterProcess?.processLocationName}}
                    </span>
                </div>
                <hr />
            </div>

            <!-- Classe do Processo -->
            <div class="message-container">
                <div>Classe do Processo:</div>
                <div class="my-3">
                    <span class="uppercase info-font text-highlight d-inline-block">
                        {{$configSchema()?.taskRegisterProcess?.processClass.name}}
                    </span>
                </div>
                <hr />
            </div>

            <!-- Resumo do Processo -->
            <div class="message-container">
                <div>Resumo do Processo:</div>
                <div class="my-3">
                    <span class="info-font text-highlight d-inline-block p-2" [safeHtmlContent]="getProcessSummary()">(Carregando...)</span>
                </div>
                <hr />
            </div>

            <!-- Interessados do Processo -->
            <div class="message-container">
                <div>Interessados do Processo:</div>
                <div class="stakeholders-container my-3">
                    @for (stakeholder of $configSchema()?.taskRegisterProcess?.stakeholders; track stakeholder) {
                        @if (!stakeholder.shouldIgnore) {
                            <div class="stakeholder info-font text-highlight m-1 p-2">
                                @if ([
                                    StakeholderType.Patriarch,
                                    StakeholderType.Organization,
                                    StakeholderType.Unit,
                                    StakeholderType.Group,
                                    StakeholderType.Comission,
                                    StakeholderType.Citizen
                                ].includes(stakeholder.type)) {
                                    <div class="stakeholder-content m-0">
                                        <b class="uppercase" [class.red]="isErrorMessage(stakeholder.name)">{{stakeholder.name}}</b>
                                        <span>{{
                                            stakeholder.isCitizenFlowInstanceOwner == true
                                                ? 'Usuário instanciador'
                                                : Utils.isNotNullOrEmpty(stakeholder.citizenCpfFormField)
                                                    ? 'CPF obtido a partir de campo do formulário'
                                                    : ''
                                        }}</span>
                                        <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                                    </div>
                                }

                                @if (stakeholder.type == StakeholderType.PublicAgent) {
                                    <div class="stakeholder-content m-0">
                                        <b class="uppercase">{{stakeholder.name.split(' - ')[0]}}</b>
                                        <span class="uppercase">{{stakeholder.name.split(' - ').splice(1).join(' - ')}}</span>
                                        <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                                    </div>
                                } @else if (stakeholder.type == StakeholderType.Company) {
                                    <div class="stakeholder-content m-0">
                                        <b class="uppercase" [class.red]="isErrorMessage(stakeholder.companyName)">{{stakeholder.companyName}}</b>
                                        <span class="uppercase" [class.red]="isErrorMessage(stakeholder.cnpj) || isErrorMessage(stakeholder.email)">
                                            {{Utils.maskCnpj(stakeholder.cnpj)}} <b>|</b> {{stakeholder.email}}
                                        </span>
                                        <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                                    </div>
                                }
                            </div>
                        }
                    }
                </div>
                <hr />
            </div>
        }

        @if (!$hasPendingTask()) {
            <!-- Task info: Realizada -->
            <div class="message-container">
                <div class="mb-3">
                    O Processo foi <b>autuado</b> no E-Docs com o seguinte protocolo:
                </div>
                <div class="process-container my-3">
                    <div class="position-relative my-1">
                        <span class="document-highlight" (click)="goToProcess()" (keyDown)="goToProcess()">
                            <span class="e-docs info-font text-highlight" matTooltip="Protocolo E-Docs do Processo">{{$process()?.protocolo}}</span>
                            <span class="info-font d-inline-block" matTooltip="Clique para ser redirecionado ao processo capturado no E-Docs">
                                <i class="fas fa-external-link-alt mr-1"></i><u class="summary">{{$process()?.resumo}}</u>
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        } @else {
            <!-- Task info: Iniciada -->
            @if (!$shouldLetPublicAgentInteract()) {
                <!-- Task body: visão do requerente -->
                <div class="message-container">
                    <div class="mb-3">
                        Aguardando autuação do Processo por:
                    </div>
                    <div>
                        <span class="uppercase info-font text-highlight d-inline-block">{{$registrar()}}</span>
                    </div>

                    @if (Utils.isNotNullOrEmpty($publicMessageHtml())) {
                        <hr />
                        <div class="public-message py-1"
                             [class.loading]="$isPublicMessageHtmlLoading()"
                             [safeHtmlContent]="$publicMessageHtml()"
                        >{{Enums.Messages.DefaultLoadingText}}</div>
                    }
                </div>
            } @else {
                <!-- Task footer: visão do executor -->
                @if (!$isReadOnly()) {
                    <div class="form-container">
                        <div class="footer">
                            @if (!$hasErrors() && !$isProcessLocationInvalid()) {
                                <button type="button" class="btn btn-outline-primary register-process"
                                        [disabled]="Utils.isNullOrEmpty($inputData()?.eDocsData?.signerId)"
                                        (click)="submit()"
                                        (keyDown)="submit()"
                                >Autuar Processo</button>
                            } @else {
                                @if ($isProcessLocationInvalid()) {
                                    <div class="mt-2">
                                        <span class="not-found info-font text-highlight p-2">
                                            O local de autuação do processo
                                            <span class="e-docs info-font text-highlight" matTooltip="Local de autuação do processo E-Docs">{{$configSchema()?.taskRegisterProcess?.processLocationName}}</span>
                                            não é mais válido
                                        </span>
                                    </div>
                                } @else {
                                    <div class="mt-2">
                                        <span class="not-found info-font text-highlight p-2">
                                            Não é possível autuar o Processo porque um ou mais erros foram identificados ao recuperar informações sobre os Interessados do Processo
                                        </span>
                                    </div>
                                }

                                <div class="mt-5">
                                    <span class="info-font document-highlight p-2">
                                        No contexto atual, a única ação possível para esta instância de Fluxo é o seu cancelamento
                                    </span>
                                </div>
                            }
                        </div>
                    </div>
                }
            }
        }
    </div>
} @else {
    <div class="wrapper loading">
        <span class="info-font text-highlight p-2">(Carregando...)</span>
    </div>
}
